import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { shouldShowErrorForField } from '../../util/forms';
import { FieldCopy } from '..';
import css from './ValidationError.module.css';

/**
 * This component can be used to show validation errors next to form
 * input fields. The component takes the final-form Field component
 * `meta` object as a prop and infers if an error message should be
 * shown.
 */
const ValidationError = props => {
  const { rootClassName, className, fieldMeta, fieldName } = props;
  const classes = classNames(rootClassName || css.root, className, 'validation-error');

  return shouldShowErrorForField(fieldMeta) ? (
    <FieldCopy className={classes} data-field={fieldName}>
      {fieldMeta.error}
    </FieldCopy>
  ) : null;
};

ValidationError.defaultProps = { rootClassName: null, className: null, fieldName: null };

const { shape, bool, string } = PropTypes;

ValidationError.propTypes = {
  rootClassName: string,
  className: string,
  fieldMeta: shape({
    touched: bool,
    error: string,
  }).isRequired,
  fieldName: string,
};

export default ValidationError;
